import superagent from 'superagent';
import webservice from './webservice';
import getCookie from './getCookie';

export default async function getCertificados(jsonBody) {
  const url = `${webservice}/getCertificados`;
  let response = {};

  await superagent
    .post(url)
    .set('Content-Type', 'application/json')
    .auth(getCookie('TMBcartToken'), { type: 'bearer' })
    .send({
      usuarioOK: getCookie('usuarioOk'),
      dominio: window.location.hostname,
    })
    .then((res) => {
      response = res.body;
    })
    .catch((err) => {
      console.log(err);
      console.log(err);
      const resp = {
        ...jsonBody,
        error: err,
        tipoMensaje: 'error',
        mensaje: 'Error',
      };
      response = resp;
    });

  return response;
}
